const Variant = (code, product, b2b) => {
  const variant = product?.variants?.find((variant) => variant.code === code);
  const getIsOnSale = () => {
    const priceKeys = b2b
      ? {containerKey: 'retailerPrice', key: 'closeout'}
      : {containerKey: 'consumerPrice', key: 'saleAdvertised'};
    if (
      variant?.[priceKeys.containerKey]?.[priceKeys.key]?.high ||
      variant?.[priceKeys.containerKey]?.[priceKeys.key]?.low
    )
      return true;
    if (
      !variant?.[priceKeys.containerKey] &&
      (product?.[priceKeys.containerKey]?.[priceKeys.key]?.high ||
        product?.[priceKeys.containerKey]?.[priceKeys.key]?.low)
    )
      return true;
    return false;
  };
  return {getIsOnSale};
};

export default Variant;
